import { useEffect } from "react";
import { inlineMetadataManager } from "../components/MarkdownComponent/MetadataManager.js";
import { mapPinType } from "../constants/products.js";
import { extractQs } from "../utils/extractQS.js";
import { buildHotelDetailURL } from "./HotelListingCard/buildHotelDetailURL.js";
const expressDealHotelId = (hotel)=>{
    if (!hotel || 'object' != typeof hotel) return '';
    const neighborhoodName = hotel.location?.neighborhoodName;
    if (hotel.sopqDealName && neighborhoodName) return `${hotel.sopqDealName}-${neighborhoodName}-${hotel.ratesSummary?.grandTotal}`;
    return '';
};
const useSetHotelPinOnMapHook = ({ displayResult, args, displaySopqOnly })=>{
    useEffect(()=>{
        const availableNames = inlineMetadataManager.getHotelOnMapList()?.map((p)=>p?.name)?.join(',');
        const newNames = displayResult?.map((h)=>h?.name || 'hotel')?.join(',');
        if (availableNames !== newNames) {
            const hotelLocationList = displayResult?.filter((hotel)=>hotel.location && hotel.location.latitude && hotel.location.longitude)?.map((hotel)=>{
                const queryString = extractQs(hotel?.hotelDetailsURL) ?? '';
                return {
                    type: mapPinType.HOTEL,
                    name: hotel?.name || 'hotel',
                    description: hotel?.description,
                    location: hotel.location,
                    lat: hotel.location.latitude,
                    lng: hotel.location.longitude,
                    hotelDetailsURL: buildHotelDetailURL(args, hotel, queryString),
                    hotel
                };
            });
            inlineMetadataManager.setHotelPinOnMap(hotelLocationList);
        }
    }, [
        displaySopqOnly,
        displayResult,
        args
    ]);
};
export { expressDealHotelId, useSetHotelPinOnMapHook };
